"use client";

import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Zap } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface InsufficientFluxModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const InsufficientFluxModal: React.FC<InsufficientFluxModalProps> = ({
  isOpen,
  onClose,
}) => {
  const navigate = useNavigate();

  const handleBuyFlux = () => {
    onClose();
    navigate("/buy");
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="bg-white/10 backdrop-blur-2xl border border-white/20 rounded-2xl p-8 max-w-sm w-full shadow-2xl text-white text-center"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-yellow-400/20 rounded-full flex items-center justify-center border-2 border-yellow-400">
                <Zap size={32} className="text-yellow-400" />
              </div>
            </div>
            <h2 className="text-2xl font-bold mb-2">Insufficient Flux</h2>
            <p className="text-white/80 mb-6">
              You do not have enough Flux to perform this action. Please
              purchase more to continue.
            </p>
            <div className="flex flex-col gap-3">
              <motion.button
                onClick={handleBuyFlux}
                className="w-full bg-gradient-to-r from-yellow-400 to-orange-500 text-black font-bold py-3 rounded-lg"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Buy More Flux
              </motion.button>
              <motion.button
                onClick={onClose}
                className="w-full bg-white/10 py-3 rounded-lg font-medium"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Cancel
              </motion.button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default InsufficientFluxModal;
